import { useLocation } from "wouter";
import type { User } from "../lib/types";
import { COURSES } from "../data/courses";
import { Sidebar } from "../components/Sidebar";
import { TopBar } from "../components/TopBar";
import { CourseArt } from "../components/CourseArt";
import { Chatbot } from "../components/Chatbot";
import { I } from "../components/Icons";

interface Props {
  user: User;
  courseId: string;
  onSignOut: () => void;
}

export function ComingSoon({ user, courseId, onSignOut }: Props) {
  const [, setLocation] = useLocation();
  const onBackToDashboard = () => setLocation("/dashboard");
  const course = COURSES.find((c) => c.id === courseId) ?? COURSES[0];

  return (
    <div className="gf-shell">
      <Sidebar active="courses" user={user} onSignOut={onSignOut} />
      <div className="gf-main">
        <TopBar
          crumbs={[
            { t: "Git Fit", href: "/dashboard" },
            { t: "My courses", href: "/dashboard" },
            { t: course.title, strong: true },
          ]}
          right={
            <button
              className="gf-btn gf-btn--ghost"
              onClick={onBackToDashboard}
            >
              <I.ChevronLeft size={14} /> All courses
            </button>
          }
        />

        <div style={{ padding: 32 }}>
          <div
            style={{
              background: "var(--nymbl-navy)",
              borderRadius: 18,
              padding: "56px 40px",
              color: "#fff",
              position: "relative",
              overflow: "hidden",
              minHeight: 320,
              display: "flex",
              alignItems: "center",
              gap: 40,
            }}
          >
            <div style={{ zIndex: 1, position: "relative", flex: 1 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.14em",
                  color: "var(--nymbl-g-cyan)",
                  marginBottom: 12,
                }}
              >
                Course {course.num} · Coming soon
              </div>
              <h1
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: 44,
                  fontWeight: 700,
                  margin: 0,
                  color: "#fff",
                  letterSpacing: "-0.02em",
                  marginBottom: 14,
                }}
              >
                {course.title}
              </h1>
              <p
                style={{
                  fontSize: 17,
                  color: "rgba(255,255,255,0.75)",
                  margin: 0,
                  maxWidth: 560,
                  lineHeight: 1.55,
                }}
              >
                {course.desc}
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: "rgba(255,255,255,0.55)",
                  marginTop: 18,
                  maxWidth: 560,
                }}
              >
                We're building this lesson next. For now, the deep walkthrough
                lives in <b style={{ color: "#fff" }}>Course 02 — Commits &
                branches</b>.
              </p>
              <div style={{ marginTop: 22, display: "flex", gap: 10 }}>
                <button
                  className="gf-btn gf-btn--gradient"
                  onClick={onBackToDashboard}
                >
                  <I.ChevronLeft size={14} /> Back to courses
                </button>
              </div>
            </div>
            <div
              style={{
                position: "relative",
                zIndex: 1,
                opacity: 0.9,
                transform: "scale(1.6)",
              }}
            >
              <CourseArt kind={course.art} />
            </div>
            <div
              style={{
                position: "absolute",
                right: -120,
                top: -160,
                width: 480,
                height: 480,
                background: "var(--nymbl-gradient-45)",
                opacity: 0.35,
                filter: "blur(80px)",
                borderRadius: "50%",
              }}
            ></div>
          </div>
        </div>
      </div>
      <Chatbot
        context={{
          screen: "coming-soon",
          courseId: course.id,
          courseTitle: course.title,
          courseDesc: course.desc,
        }}
      />
    </div>
  );
}
